import React, { Component } from 'react'
import Card5 from '../components/cards/Card5'
import BlogsMP from '../components/sections/BlogsMP'
import PagesHeader from '../components/sections/PagesHeader'



import blog1 from "../images/blog111.webp"
import blog2 from '../images/blog2222.jpg'
import blog3 from '../images/blog3333.png'
import blog4 from '../images/blog4.webp'
import logo_blog from '../images/logoblog.jpg'
import ui_ux from '../images/ui-ux.jpg'
import applications from '../images/applicationBlog.jpg'
import veb_site_services from '../images/veb_site_services.png'
import e_ticaret_saytlari from '../images/e-ticaret-vepsite.jpg'
import smm_image from '../images/smm_image.jpg'
import seo_image from '../images/seo_image.png'
import robot_image from '../images/robot.webp'
import { Helmet } from 'react-helmet'

const images = {
    blog1: blog1,
    blog2: blog2,
    blog3: blog3,
    blog4: blog4,
    logo_blog: logo_blog,
    ui_ux: ui_ux,
    applications: applications,
    veb_site_services: veb_site_services,
    e_ticaret_saytlari: e_ticaret_saytlari,
    smm_image: smm_image,
    seo_image: seo_image,
    robot_image: robot_image
}

export class Blogs extends Component {
    render() {
        const { blogs } = this.props;
        return (
            <main>

                <Helmet>
                    {/* Meta Title */}
                    <title>ITnova Blog - İT, İnnovasiya, Veb Dizayn və Texnologiya Məqalələri</title>

                    {/* Meta Description */}
                    <meta name="description" content="ITnova bloqunda İT, innovasiya, veb dizayn, mobil tətbiq hazırlığı, SEO və robototexnika sahəsində faydalı məqalələr oxuyun. Ən son texnoloji trendləri bizimlə kəşf edin." />

                    {/* Meta Keywords */}
                    <meta name="keywords" content="ITnova blog, İT məqalələri, veb dizayn məqalələri, texnologiya xəbərləri, innovasiya, SEO məqalələri, mobil tətbiq bloqu, robototexnika, texnoloji trendlər, itnova.az" />

                    {/* Open Graph Meta Tags (for social sharing) */}
                    <meta property="og:title" content="ITnova Blog - İT, İnnovasiya, Veb Dizayn və Texnologiya Məqalələri" />
                    <meta property="og:description" content="İT, innovasiya, veb dizayn və texnologiyaya dair faydalı məqalələri ITnova bloqunda oxuyun. Bizimlə ən son texnoloji yenilikləri kəşf edin." />
                    <meta property="og:url" content="https://itnova.az/blogs" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://itnova.az/static/media/logo.76d56b1f9b610982be1a.png" />
                </Helmet>


                <PagesHeader
                    title="Bloglar"
                    text="Texnologiya və biznes dünyasında ən son yeniliklər və fikirlər burada."
                    className="header_back"

                />

                {/* <BlogsMP /> */}

                <section className='container pt-[52px] pb-[32px]'>
                    <div className='grid grid-cols-3 gap-[20px] mt-[32px] max-[1001px]:grid-cols-2 max-[650px]:grid-cols-1'>
                        {
                            blogs?.map(blog => (
                                <Card5
                                    key={blog?.id}
                                    title={blog?.title}
                                    text={blog?.text}
                                    image={images[blog?.image]}
                                    path={`/blogs/${blog?.path}`}
                                />
                            ))
                        }
                    </div>
                </section>




            </main>
        )
    }
}

export default Blogs